import { getInstance } from './getInstance'
import traceService from '../../components/shared/trace/trace-service'
import { store } from '../../store/store'
import { AUTH_METHODS } from '../../utils/constant'
import sharedService from '@/utils/shared-service'

const authSDK = {
  callAuthSDKMethod: async (methodName, methodParam) => {
    return new Promise(async (resolve, reject) => {
      store.commit('loaderOn', true)
      traceService.addRequestLogs({
        methodName,
        params: methodParam
      })
      if (methodName === AUTH_METHODS.AUTHENTICATE) {
        methodParam.windowRef = authSDK.getWindowRef()
      }
      console.log(`[START] CALLING AUTHSDK METHOD:  ${methodName} - with: `, methodParam)
      const authSDKInstance = getInstance()
      const response = await authSDKInstance[methodName](methodParam).catch(err => {
        store.commit('loaderOn', false)
        traceService.addResponseLogs(methodName, err)
        console.log('[START] AUTH SDK RESPONDED WITH ERROR: ', err)
        reject(err)
      })
      if (response) {
        traceService.addResponseLogs(methodName, response)
        console.log('[START] AUTH SDK RESPONDED WITH : ', response)
        resolve(response)
      }
    })
  },

  getWindowRef: () => {
    if (store.getters.authPresentationStyle === 'POPUP_BASED') {
      const { width, height } = sharedService.getResolution()
      window.authIframe && window.authIframe.close()
      let authPopup = window.open('', '_blank', 'popup')
      let left = (screen.width - width) / 2
      let top = (screen.height - height) / 2
      if (left <= 0 || top <= 0) {
        left = 600
        top = 200
      }
      authPopup.moveTo(left, top)
      authPopup.resizeTo(width, height)
      window.authSdkWindow = authPopup
      setTimeout(() => {
        window.document.getElementById('iframeContainer').classList.remove('show')
      }, 0)
      return window.authSdkWindow
    } else {
      return window.authIframe
    }
  }
}
export default authSDK
